import '../static/Modal.css';
import React__default, { forwardRef, useRef, useImperativeHandle, useCallback, useEffect } from "react";
import clsx from "clsx";
import { S as ScreenReaderContent } from "./ScreenReaderContent.CmT4o4X9.mjs";
import { S as SvgClose1Px } from "./close-1px.BL6ZlEPp.mjs";
import { b as Button } from "./Button.hIh6dJaA.mjs";
import { g as getClassName } from "./classNames.DrrTR-Hz.mjs";
const modal = `_modal_cbeda09`;
const full = `_full_9a5dfad`;
const close = `_close_fbda74b`;
const content = `_content_07ce48d`;
const centered = `_centered_e2ba4cb`;
const styles = { modal, full, close, content, centered };
const Modal = forwardRef(
  ({
    className,
    closeLabel = "Close Dialog",
    children,
    focusCloseButton = true,
    open,
    onClose,
    onOpen,
    centeredContent = false,
    showCloseButton = true,
    ...rest
  }, ref) => {
    const innerRef = useRef(null);
    const contentRef = useRef(null);
    useImperativeHandle(ref, () => innerRef.current);
    const closeModal = useCallback(() => {
      if (!innerRef.current)
        return;
      innerRef.current.close();
      document.documentElement.classList.remove(
        getClassName("html", "no-scroll")
      );
    }, []);
    const openModal = useCallback(() => {
      var _a;
      if (!innerRef.current)
        return;
      innerRef.current.showModal();
      document.documentElement.classList.add(getClassName("html", "no-scroll"));
      if (!focusCloseButton) {
        (_a = innerRef == null ? void 0 : innerRef.current) == null ? void 0 : _a.focus();
      }
      if (onOpen)
        onOpen();
    }, [focusCloseButton, onOpen]);
    useEffect(() => {
      if (open) {
        openModal();
      } else {
        closeModal();
      }
    }, [open, openModal, closeModal]);
    return /* @__PURE__ */ React__default.createElement(
      "dialog",
      {
        ...rest,
        ref: innerRef,
        onClose,
        onClick: (event) => {
          var _a;
          if ((_a = contentRef.current) == null ? void 0 : _a.contains(event.target)) {
            return;
          }
          closeModal();
        },
        className: clsx(styles.modal, className, {
          [styles.full]: !showCloseButton,
          [styles.centered]: centeredContent
        })
      },
      showCloseButton && /* @__PURE__ */ React__default.createElement(
        Button,
        {
          variant: "white",
          onClick: closeModal,
          rounded: true,
          className: styles.close
        },
        /* @__PURE__ */ React__default.createElement(ScreenReaderContent, null, closeLabel),
        /* @__PURE__ */ React__default.createElement(SvgClose1Px, { "aria-hidden": "true" })
      ),
      /* @__PURE__ */ React__default.createElement("div", { ref: contentRef, className: styles.content }, children)
    );
  }
);
export {
  Modal as M
};
//# sourceMappingURL=Modal.DtcS7OoI.mjs.map
